<template>
  <v-row>
    <v-col cols="3">
      <v-sheet class="pt-4" color="transparent"><!-- style="position:sticky; top:100px" -->
        <v-card width="180px" outlined>
          <v-card-text>
            <v-responsive class="align-center text-center" :aspect-ratio="1/1">
              <img :src="require(`@/assets/appAsset-brand--${activeBiller.brand}.svg`)" :alt="activeBiller.name" width="90%">
            </v-responsive>
          </v-card-text>
        </v-card>
        <v-list class="pl-0" color="transparent">
          <v-list-item class="pl-0">
            <v-list-item-content class="d-block text--secondary font-weight-medium">Compatibilidad</v-list-item-content>
          </v-list-item>
          <v-list-item class="pl-0">
            <v-list-item-content>
              <v-list-item-title class="text--secondary">Países</v-list-item-title>
              <v-list-item-subtitle class="d-block pt-1 caption text--primary">
                <img class="mr-2" v-for="d in activeBiller.countries" :key="d" :src="require(`@/assets/appAsset-flag--${d}.svg`)" :alt="activeBiller.name" height="16px">
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <!-- <v-list-item class="pl-0">
            <v-list-item-content>
              <v-list-item-title class="text--secondary">Agencia tributaria</v-list-item-title>
              <v-list-item-subtitle class="d-block pt-1 caption text--primary">
                <img class="mr-2" v-for="d in activeBiller.taxAgencies" :key="d" :src="require(`@/assets/appAsset-brand--${d}.svg`)" :alt="d" height="16px">
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item> -->
          <v-list-item class="pl-0">
            <v-list-item-content>
              <v-list-item-title class="text--secondary">Tipos de facturas</v-list-item-title>
              <v-list-item-subtitle class="pt-1">
                <span class="d-block mb-1 caption text--primary" v-for="d in activeBiller.invoiceTypes" :key="d">{{d}}</span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="pl-0" v-if="activeBiller.otherTypes && activeBiller.otherTypes.length">
            <v-list-item-content>
              <v-list-item-title class="text--secondary">Otros tipos de documentos</v-list-item-title>
              <v-list-item-subtitle class="pt-1">
                <span class="d-block mb-1 caption text--primary" v-for="d in activeBiller.otherTypes" :key="d">{{d}}</span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-sheet>
    </v-col>

    <v-col cols="9">
      <v-row>
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="ml-n1 subtitle-1 text--secondary font-weight-medium">
            <router-link :to="{name: 'Integrations'}" class="subtitle-1 routerLink font-weight-medium">Integraciones</router-link>
            <v-icon class="mx-1" color="secondary">mdi-chevron-right</v-icon>{{activeBiller.name}}
          </v-toolbar-title>
        </v-toolbar>
      </v-row>
      <v-row no-gutters>
        <v-col md="3">
          <span class="d-block caption">Documentación</span>
          <v-btn :href="`${$DOCS_BASE}${activeBiller.docs}`" target="_blank" color="primary" text :ripple="false">Ir a la documentación<v-icon right small>mdi-open-in-new</v-icon></v-btn>
        </v-col>
        <v-divider vertical />
        <v-col md="3" class="ml-2">
          <span class="d-block caption">Sitio web</span>
          <v-btn :href="activeBiller.website" target="_blank" color="primary" text :ripple="false">Visitar el sitio<v-icon right small>mdi-open-in-new</v-icon></v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-card>
            <v-toolbar color="transparent" flat height="55">
              <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">
                <template v-if="instance.id">Actualizar conexión</template><template v-else>Conectar</template> {{activeBiller.name}}
              </v-toolbar-title>
            </v-toolbar>
            <v-divider />
            <v-card-text class="pa-0">
              <v-list class="py-5" color="background" dense>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="ml-1 text--secondary subtitle-2 font-weight-medium">Api Key</v-list-item-title>
                    <v-list-item-subtitle class="font-weight-regular">
                      <v-col cols="6" class="pa-0">
                        <v-text-field v-model="$v.billerConnection.api_key.$model" :error="$v.billerConnection.api_key.$error" background-color="white" outlined required single-line dense maxlength="254" :placeholder="activeBiller.placeholder" hide-details />
                      </v-col>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="ml-1 text--secondary subtitle-2 font-weight-medium">Account ID</v-list-item-title>
                    <v-list-item-subtitle class="font-weight-regular">
                      <v-col cols="6" class="pa-0">
                        <v-text-field v-model="$v.billerConnection.extra_data.account_id.$model" background-color="white" dense :error="$v.billerConnection.extra_data.account_id.$error" hide-details maxlength="24" outlined single-line />
                      </v-col>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item class="pt-16" v-if="activeBiller.warning">
                  <v-list-item-content>
                    <v-alert class="mb-0 body-2" dark dense color="primary" border="left" type="info">{{activeBiller.warning}}</v-alert>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
            <v-divider />
            <v-card-actions class="pa-4">
              <v-btn v-if="instance.id" @click="destroyBillerConnection" dark color="red">Desconectar</v-btn>
              <v-spacer />
              <v-btn @click="instance.id ? updateBillerConnection() : createBillerConnection()" :loading="loaderConnect" color="primary">
                <template v-if="instance.id">Actualizar conexión</template>
                <template v-else>Conectar</template>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { maxLength, required } from 'vuelidate/lib/validators'
import GenericViewMixin from '@/mixins/GenericViewMixin'

import billers from '../../collections/billers'

export default {
  mixins: [
    GenericViewMixin
  ],
  data: () => ({
    billers: billers,
    billerConnection: {
      biller: '',
      api_key: '',
      extra_data: {
        account_id: null
      }
    },
    loaderConnect: false
  }),
  computed: {
    ...mapState({
      instance: state => state.billers.billerconnectionsList[0] || {}
    }),
    activeBiller () {
      return this.billers.find(b => b.id === this.$route.params.id)
    }
  },
  created () {
    this.billerConnection.biller = this.$route.params.id

    this.$store.dispatch('billers/LIST', {
      resource: 'billerconnections',
      query: {
        biller: this.$route.params.id
      }
    })
  },
  methods: {
    createBillerConnection () {
      this.$v.billerConnection.$touch()

      if (this.$v.billerConnection.$invalid) {
        return false
      }

      this.loaderConnect = true

      this.$store.dispatch('billers/CREATE', {
        resource: 'billerconnections',
        payload: this.billerConnection
      })
      .then(() => {
        this.$dialog.message.info(`Se ha conectado ${this.activeBiller.name}.`)
        this.resetBillerConnection()
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
      .finally(() => {
        this.loaderConnect = false
      })
    },
    destroyBillerConnection () {
      this.$dialog.warning({
        title: `Desconectar ${this.activeBiller.name}`,
        text: `
          <span class="d-block mb-4">¿Estás seguro de desconectar este proveedor de facturación?</span>
          <span class="d-block font-weight-medium">Esta acción no se puede deshacer.</span>
        `,
        actions: [
          {
            color: 'red',
            text: 'Continuar',
            handle: () => {
              this.$store.dispatch('billers/DESTROY', {
                resource: 'billerconnections',
                id: this.instance.biller
              })
              .then(() => {
                this.$dialog.message.info(`El proveedor de facturación ${this.activeBiller.name} ha sido desconectado.`)
                this.$router.push({ name: 'Integrations' })
              })
              .catch((error) => {
                this.$dialog.message.warning(this.parseErrors(error.response.data))
              })
            }
          }
        ]
      })
    },
    resetBillerConnection () {
      this.billerConnection = {
        biller: this.activeBiller.id,
        api_key: '',
        extra_data: {
          account_id: null
        }
      }
      this.$v.billerConnection.$reset()
    },
    updateBillerConnection () {
      this.$v.billerConnection.$touch()

      if (this.$v.billerConnection.$invalid) {
        return false
      }

      this.loaderConnect = true

      this.$store.dispatch('billers/UPDATE', {
        resource: 'billerconnections',
        id: this.instance.id,
        payload: this.billerConnection
      })
      .then(() => {
        this.$dialog.message.info(`Se ha actualizado la conexión con ${this.activeBiller.name}.`)
        this.resetBillerConnection()
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
      .finally(() => {
        this.loaderConnect = false
      })
    }
  },
  validations: {
    billerConnection: {
      api_key: {
        required,
        maxLength: maxLength(254)
      },
      extra_data: {
        account_id: {
          required,
          maxLength: maxLength(24)
        }
      }
    }
  }
}
</script>